import { HttpClient, RequestParams, TraceDataType } from './http-client';

import { loggerCan } from '@/data/utils/loggerUtil';
import { logger } from '@/logging/logger';

export class Campaign<SecurityDataType = unknown> {
	http: HttpClient<SecurityDataType>;

	constructor(http: HttpClient<SecurityDataType>) {
		this.http = http;
	}

	/**
 * No description
 *
 * @tags campaign
 * @name CampaignSaveCampaignCreate
 * @summary Save campaign data
 * @request POST:/store/{storeId}/campaign/save_campaign
 * @secure
 * @response `200` `{
  \** Status of the data persistense *\
    status?: string,

}` The requested completed successfully.
 * @response `400` `void` Bad request. The request could not be understood by the server due to malformed syntax.
 * @response `401` `void` Not authenticated. The user session is not valid.
 * @response `403` `void` The user is not authorized to perform the specified request.
 * @response `404` `void` The specified resource could not be found.
 * @response `500` `void` Internal server error. For details, see the server log files.
 */
	campaignSaveCampaignCreate = (
		storeId: string,
		query: {
			campaignOrderNumber?: string;
			/** Full name of the user */
			name?: string;
			/** First name of the user */
			firstName?: string;
			/** last name of the user */
			lastName?: string;
			/** Email of the user */
			email: string;
			/** Phone number of the user */
			campaignPhone1?: string;
			/** Date of birth of the user */
			campaignDOB?: string;
			/** Campaign text */
			txt?: string;
			/** Campaign text answere */
			anstxt?: string;
			/** User age */
			age?: string;
			/** Address */
			street?: string;
			/** house number */
			houseNumber?: string;
			/** Postal code */
			postalCode?: string;
			/** Address */
			place?: string;
			/** Campaign Answere */
			campaignAns?: string;
			/** Campaign Extra Answere */
			campaignAnsExtra?: string;
			/** challenge Question A */
			chalQuestionA?: string;
			/** challenge Question B */
			chalQuestionB?: string;
			/** challenge Question C */
			chalQuestionC?: string;
			/** challenge Question D */
			chalQuestionD?: string;
			/** challenge Question E */
			chalQuestionE?: string;
			/** Campaign name */
			campaignName?: string;
			/** User scubscription */
			itnlSubscription?: string;
			/** opt in source */
			optInSource?: string;
			/** Campaign date needed */
			campaignDateNeeded?: string;
		},
		params: RequestParams = {}
	) => {
		const { _requestId: requestId, skipErrorLogging, ..._params } = params as any;
		let traceData: TraceDataType | undefined;

		if (
			loggerCan('trace') &&
			(!this.http.traceDetails || this.http.traceDetails['campaignSaveCampaignCreate'])
		) {
			traceData = {
				requestId,
				msg: 'API request',
				url: `${this.http.baseUrl}/store/${storeId}/campaign/save_campaign`,
				params: _params,
				query: query,
				methodName: 'campaignSaveCampaignCreate',
			};
			logger.trace(traceData);
		}
		return this.http.request<
			{
				/** Status of the data persistense */
				status?: string;
			},
			void
		>({
			path: `/store/${storeId}/campaign/save_campaign`,
			method: 'POST',
			query: query,
			secure: true,
			format: params.format ?? 'json',
			storeId,
			traceData,
			skipErrorLogging,
			..._params,
		});
	};
}
